import React, { useEffect, useState } from 'react';

import { CircularProgress } from 'react-scale/components/design-system';
import { makeStyles } from 'design-system/styles';

import DownloadableViewError from './DownloadableViewError';

interface DownloadableEmbeddedAppViewProps {
  attachmentUrl: string;
  isAuditMode?: boolean;
}

interface AttachmentContent {
  embeddedAppLink: string;
  data: Record<string, any>;
}

export default function DownloadableEmbeddedAppView({
  attachmentUrl,
  isAuditMode,
}: DownloadableEmbeddedAppViewProps) {
  const styles = useAttachmentViewStyles();
  const [content, setContent] = useState<null | AttachmentContent>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const res = await fetch(attachmentUrl).then(res => res.json());
      setContent(res);
      setLoading(false);
    };

    fetchData();
  }, [setContent, setLoading, attachmentUrl]);

  if (loading) {
    return <CircularProgress />;
  }

  if (content === null || !content.embeddedAppLink) {
    return <DownloadableViewError />;
  }

  return (
    <div className={styles.container}>
      <iframe
        className={styles.iframe}
        src={`${content.embeddedAppLink}?attachmentUrl=${encodeURIComponent(
          attachmentUrl,
        )}&isAuditMode=${isAuditMode ?? false}`}
      />
    </div>
  );
}

const useAttachmentViewStyles = makeStyles({
  container: {
    margin: 24,
    padding: 32,
  },
  iframe: {
    border: 'none',
    height: '1000px',
    width: '100%',
  },
});
